export const roleOwner = 'ROLE_OWNER';
export const roleManager = 'ROLE_MANAGER';
export const roleViewer = 'ROLE_VIEWER';
export const roleCafe24Master = 'ROLE_CAFE24_MASTER';
export const roleGuest = 'ROLE_GUEST';

export const basicRoles = [roleOwner, roleManager, roleViewer];
